<template>
  <button @click="buttonClicked" class="btn btn-lg shadow customButtonTheme">
    <LoadingComponent
      v-if="isLoading"
      :large-spinner="false"
    ></LoadingComponent>
    {{ button.label }}
  </button>
</template>

<script lang="ts">
import { button } from "@entersekt/types/build/3-5-0/endpoint";
import LoadingComponent from "@/components/LoadingComponent.vue";
import { defineComponent, PropType } from "vue";
import tinycolor from "tinycolor2";

const black = "black";
const white = "white";

export default defineComponent({
  name: "ButtonComponent",
  components: { LoadingComponent },

  data() {
    return {
      isLoading: false,
    };
  },

  props: {
    button: {
      required: true,
      type: Object as PropType<button>,
    },
    theme: {
      required: true,
      type: String,
    },
  },

  watch: {
    button: {
      handler() {
        this.isLoading = false;
      },
      deep: true,
    },
  },

  computed: {
    textColor() {
      const currentColor = tinycolor(this.theme);
      if (currentColor.isLight()) {
        return black;
      }
      return white;
    },

    onHover(): string {
      const currentColor = tinycolor(this.theme);
      if (currentColor.isLight()) {
        return currentColor.darken(10).toString();
      }
      return currentColor.lighten(10).toString();
    },
  },

  methods: {
    buttonClicked() {
      this.isLoading = true;
      this.$emit("buttonClicked", this.button.action, this.button.actionNext);
    },
  },

  emits: ["buttonClicked"],
});
</script>

<style scoped>
.customButtonTheme {
  background-color: v-bind("theme");
  color: v-bind("textColor");
  transition: all 0.4s ease-out;
}

.btn:hover {
  color: v-bind("textColor");
}

.customButtonTheme:hover {
  background-color: v-bind("onHover");
}

button:disabled {
  background-color: v-bind("onHover");
  color: v-bind("textColor");
}

.customButtonTheme:focus-visible {
  background-color: v-bind("theme");
  color: v-bind("textColor");
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow:
    0 0 0 2px #fff,
    0 0 0 4px #000,
    var(--bs-box-shadow) !important;
}
</style>
